module.exports = __webpack_public_path__ + "img/down.b42fdd01.svg";